import axios from '../axiosConfig';
const options = signal => ({ signal, timeout: 5000, withCredentials: false,
  skipAuthSessionHandling: true, __serviceAvailabilityProbe: true, headers: { Authorization: undefined } });

export const readPublicStatus = signal => axios.get(new URL('/service-status.json', window.location.origin).href, options(signal)).then(response => response.data);
export const checkPublicAvailability = signal => axios.get('/api/availability', options(signal)).then(response => {
  if (response.data?.success !== true || response.data?.data?.available !== true) throw new Error('Invalid availability response');
  return response.data.data;
});

const instant = value => typeof value === 'string' && /(?:Z|[+-]\d{2}:\d{2})$/.test(value) && Number.isFinite(Date.parse(value));
export function validatePublicStatus(value) {
  if (!value || value.version !== 1 || !['normal', 'maintenance'].includes(value.state) || !instant(value.updatedAt)) return null;
  if (value.expectedRecoveryAt != null && !instant(value.expectedRecoveryAt)) return null;
  if (value.message != null && (typeof value.message !== 'object' || Array.isArray(value.message))) return null;
  const message = {};
  for (const language of ['en', 'fr', 'cn']) {
    const copy = value.message?.[language];
    if (copy !== undefined && (typeof copy !== 'string' || copy.length > 1000)) return null;
    if (copy) message[language] = copy;
  }
  return { state: value.state, updatedAt: value.updatedAt, expectedRecoveryAt: value.expectedRecoveryAt || null, message };
}
export function publicStatusURL(value) {
  try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password ? url.href : null; }
  catch { return null; }
}
